import React from "react";

function NoteExpertVideo(props) {
  return (
    <li>
      <iframe
        id="ytplayer"
        type="text/html"
        width="506"
        height="288"
        src={props.link}
        style={{ borderRadius: 15 }}
        frameBorder="0"
        allowFullScreen
      ></iframe>
    </li>
  );
}

export default NoteExpertVideo;
